// ---------------------------------------------------------------------------
// Usage rollups + session behavior (issue #1453, epic #1448)
// ---------------------------------------------------------------------------

import { apiRequest } from './http';

export type UsageRollupGranularity = 'day' | 'week' | 'month';

export interface UsageRollupWindow {
  granularity: UsageRollupGranularity;
  start: string;
  end: string;
}

export interface ActiveUsersDataPoint {
  timestamp: string;
  value: number;
}

export interface TopCountEntry {
  key: string;
  count: number;
}

export interface UsageRollupResult {
  granularity: UsageRollupGranularity;
  period: { start: string; end: string };
  activeUsers: ActiveUsersDataPoint[];
  topRoutes: TopCountEntry[];
  topFeatures: TopCountEntry[];
  queryVolumeByEntityType: TopCountEntry[];
}

export interface SessionBehaviorResult {
  period: { start: string; end: string };
  sessionCount: number;
  avgDurationMs: number;
  avgDepth: number;
  topDropOffRoutes: TopCountEntry[];
}

/** `GET /api/v1/analytics/usage-rollup` — gated the same as `/analytics/summary` (Administrator or `analytics:read`). */
export async function fetchUsageRollup(window: UsageRollupWindow): Promise<UsageRollupResult> {
  const params = new URLSearchParams({
    granularity: window.granularity,
    start: window.start,
    end: window.end,
  });
  return apiRequest<UsageRollupResult>(`/analytics/usage-rollup?${params.toString()}`);
}

/** `GET /api/v1/analytics/session-behavior` — same gate as `fetchUsageRollup`. */
export async function fetchSessionBehavior(window: {
  start: string;
  end: string;
}): Promise<SessionBehaviorResult> {
  const params = new URLSearchParams({ start: window.start, end: window.end });
  return apiRequest<SessionBehaviorResult>(`/analytics/session-behavior?${params.toString()}`);
}
